import React from 'react';

import PropTypes from 'prop-types';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByProvince = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByProvince },
    iotOrderDetailsSection: { provincesListIoT }
  } = localizedStrings;

  return (
    <div>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, province: value });
        }}
        label={filterByProvince}
        options={provincesListIoT}
        value={filters.province}
      />
    </div>
  );
};

FilterByProvince.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByProvince;
